




































import Vue from "vue";

export default Vue.extend({
    name: "MyClassDetailOverview",
    props: {
        classOverviewInfo: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            classImage: require("@/assets/class.png")
        };
    }
});
